import { render, staticRenderFns } from "./SectionBtnCard.vue?vue&type=template&id=0190cdaa&scoped=true&"
import script from "./SectionBtnCard.vue?vue&type=script&lang=js&"
export * from "./SectionBtnCard.vue?vue&type=script&lang=js&"
import style0 from "./SectionBtnCard.vue?vue&type=style&index=0&id=0190cdaa&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0190cdaa",
  null
  
)

export default component.exports